module.exports = __webpack_public_path__ + "static/media/ionicon.1549166b.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/ionicon/ionicon.eot?phty4a
 ** module id = 76
 ** module chunks = 0
 **/